import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Box, TextField, Button, Typography, Alert, Paper } from '@mui/material';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const user = await login(email, password);
      navigate(user?.default_landing_path || '/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" align="center" gutterBottom>
            Yaplar
          </Typography>
          <Typography variant="h6" align="center" gutterBottom color="text.secondary">
            Sign In
          </Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <form onSubmit={handleSubmit}>
            <TextField fullWidth label="Email" type="email" value={email}
              onChange={e => setEmail(e.target.value)} margin="normal" required />
            <TextField fullWidth label="Password" type="password" value={password}
              onChange={e => setPassword(e.target.value)} margin="normal" required />
            <Button fullWidth variant="contained" type="submit" sx={{ mt: 2 }} size="large">
              Sign In
            </Button>
          </form>
          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <Box sx={{ textAlign: 'center', mb: 2 }}>
              <Link to="/forgot-password" style={{ color: '#1a237e', fontSize: 14, textDecoration: 'none', fontWeight: 600 }}>Forgot password?</Link>
            </Box>
                        <Link to="/register">Don't have an account? Register</Link>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}
